module.exports = __webpack_public_path__ + "img/light-on-dent-red.4da02c0e.svg";